import axios from 'axios';

export const getTags = async (tagType, filter) => {
    try {
        let resp = await axios.get(`${process.env.REACT_APP_HOST}/tags/${tagType}/${filter}`);
        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            return [];
        }
    } catch (e) {
        return [];
    }
};

export const postTag = async (tagType, filter) => {
    try {
        let resp = await axios.post(`${process.env.REACT_APP_HOST}/tags/${tagType}/${filter}`);
        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            return {id:"", pt: "", en: ""};
        }
    } catch (e) {
        return {id:"", pt: "", en: ""};
    }
};